import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import { MATERIAL_STATES } from '../constants';
import useStyles from '../styles';

const MaterialStatus = ({ fc, fg }) => {
  const classes = useStyles();

  const getStatusContent = () => {
    if (fc === 3) return { icon: '↩︎', text: MATERIAL_STATES.RETORNADO };
    if (fg === 2) return { icon: '❓🟢', text: MATERIAL_STATES.FINALIZADO };
    if (fg === 1) return { icon: '🟢', text: MATERIAL_STATES.FINALIZADO };
    if (fc === 2) return { icon: '❓🟡', text: MATERIAL_STATES.POR_REVISAR };
    if (fc === 1) return { icon: '🟡', text: MATERIAL_STATES.POR_REVISAR };
    if (fc === 0) return { icon: '⚪', text: MATERIAL_STATES.PENDIENTE };
    return null;
  };

  const status = getStatusContent();
  if (!status) return null;

  return (
    <div className={classes.actionBtnsContainer}>
      {status.icon} <Typography>{status.text}</Typography>
    </div>
  );
};

MaterialStatus.propTypes = {
  fc: PropTypes.number,
  fg: PropTypes.number
};

MaterialStatus.defaultProps = {
  fc: null,
  fg: null
};

export default MaterialStatus;
